import { render, staticRenderFns } from "./TableMerge.vue?vue&type=template&id=8564d04e&scoped=true&"
import script from "./TableMerge.vue?vue&type=script&lang=js&"
export * from "./TableMerge.vue?vue&type=script&lang=js&"
import style0 from "./TableMerge.vue?vue&type=style&index=0&id=8564d04e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8564d04e",
  null
  
)

export default component.exports